// #564: Das Dashboard-Layout im Schlüssel `dashboard` der Benutzer-
// Einstellungen. Die Ids sind die aus bereiche.js; #569 (Bereiche
// ausblenden und sortieren) baut darauf auf.
//
// Das Dashboard kennt bisher drei Schalter, gespeichert im Cookie
// `dashboardHiddenColumns_<mail>` als { emails, teams, showTodayCalendar }.
// Dieselbe Form nimmt saveHiddenColumns() entgegen, je mit nur einem Teil.
// #569: Das Cookie bleibt Spiegel fürs erste Bild. Weitere ausgeblendete
// Bereiche (`weitere`) und die Reihenfolge stehen nur darin, wenn es sie gibt;
// sonst bleibt seine Form wie vorher.

const SCHALTER_ZU_BEREICH = [['emails', 'mails'], ['teams', 'teams']];

const liste = (w) => (Array.isArray(w) ? w.filter((x) => typeof x === 'string') : []);

/**
 * Layout aus dem gespeicherten Stand, oder null, wenn es noch keinen gibt.
 * @param {{ ausgeblendet?: string[], reihenfolge?: string[], heuteAlsKalender?: boolean } | undefined} dashboard
 * @returns {{ ausgeblendet: string[], reihenfolge: string[], showTodayCalendar: boolean } | null}
 */
export function layoutAusEinstellungen(dashboard) {
  if (!dashboard || typeof dashboard !== 'object') return null;
  return {
    ausgeblendet: liste(dashboard.ausgeblendet),
    reihenfolge: liste(dashboard.reihenfolge),
    showTodayCalendar: dashboard.heuteAlsKalender === true
  };
}

/** Layout aus dem Cookie (alte und neue Form), oder null. */
export function layoutAusCookie(gespeichert) {
  if (!gespeichert || typeof gespeichert !== 'object') return null;
  return {
    ausgeblendet: [
      ...SCHALTER_ZU_BEREICH.filter(([schalter]) => gespeichert[schalter]).map(([, id]) => id),
      ...liste(gespeichert.weitere)
    ],
    reihenfolge: liste(gespeichert.reihenfolge),
    showTodayCalendar: !!gespeichert.showTodayCalendar
  };
}

/** Das Layout als Cookie-Spiegel; ohne weitere Bereiche und Reihenfolge in der alten Form. */
export function cookieAusLayout(layout) {
  const ids = SCHALTER_ZU_BEREICH.map(([, id]) => id);
  const weitere = layout.ausgeblendet.filter((id) => !ids.includes(id));
  return {
    emails: layout.ausgeblendet.includes('mails'),
    teams: layout.ausgeblendet.includes('teams'),
    showTodayCalendar: layout.showTodayCalendar,
    ...(weitere.length ? { weitere } : {}),
    ...(layout.reihenfolge.length ? { reihenfolge: layout.reihenfolge } : {})
  };
}

/**
 * Die Änderung für den Schlüssel `dashboard` zu einem Aufruf von
 * saveHiddenColumns(). Nur die genannten Teile ändern sich; andere Ids in
 * `ausgeblendet` (#569) bleiben stehen.
 * @param {object | undefined} dashboard  bisheriger Stand
 * @param {{ emails?: boolean, teams?: boolean, showTodayCalendar?: boolean }} naechster
 */
export function dashboardAenderung(dashboard, naechster) {
  const teil = {};
  if (SCHALTER_ZU_BEREICH.some(([schalter]) => schalter in naechster)) {
    let liste = dashboard && Array.isArray(dashboard.ausgeblendet) ? dashboard.ausgeblendet.slice() : [];
    for (const [schalter, id] of SCHALTER_ZU_BEREICH) {
      if (!(schalter in naechster)) continue;
      liste = liste.filter((x) => x !== id);
      if (naechster[schalter]) liste.push(id);
    }
    teil.ausgeblendet = liste;
  }
  if ('showTodayCalendar' in naechster) teil.heuteAlsKalender = !!naechster.showTodayCalendar;
  return teil;
}
